import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';
import type { StatsUnit } from '@/shared/api/types';

export type FanSort = 'coin' | 'recent';

export const FANS_PAGE_SIZE = 20;

export const audienceKeys = {
  all: ['audience'] as const,
  summary: () => [...audienceKeys.all, 'summary'] as const,
  trend: (params: { from: string; unit: StatsUnit }) =>
    [...audienceKeys.all, 'trend', params] as const,
  fans: (params: { page: number; sort: FanSort }) => [...audienceKeys.all, 'fans', params] as const,
};

export const audienceSummaryQueryOptions = () =>
  queryOptions({
    queryKey: audienceKeys.summary(),
    queryFn: ({ signal }) => unwrap(api.GET('/api/audience/summary', { signal })),
  });

/** 추이 — to 는 비워 두면 서버가 최신 스냅샷 일자(D-1)로 잡는다 */
export const audienceTrendQueryOptions = (params: { from: string; unit: StatsUnit }) =>
  queryOptions({
    queryKey: audienceKeys.trend(params),
    queryFn: ({ signal }) =>
      unwrap(api.GET('/api/audience/trend', { params: { query: params }, signal })),
    placeholderData: keepPreviousData,
  });

export const fansQueryOptions = (params: { page: number; sort: FanSort }) =>
  queryOptions({
    queryKey: audienceKeys.fans(params),
    queryFn: ({ signal }) =>
      unwrap(
        api.GET('/api/audience/fans', {
          params: { query: { ...params, limit: FANS_PAGE_SIZE } },
          signal,
        }),
      ),
    placeholderData: keepPreviousData,
  });
